<template>
  <BsModal
    :value="!!egress_profile_matter"
    :title="$t('studyPlan.academicLoad.selectPrerequisites')"
    @input="(open) => !open && emit('close')"
  >
    <template v-if="egress_profile_matter">
      <input
        v-model="search"
        type="search"
        class="form-control form-control-sm mb-2"
        :placeholder="$t('studyPlan.academicLoad.searchMatter')"
      />
      <div class="options-list">
        <div
          v-for="option in visibleOptions"
          :key="option.id"
          class="custom-control custom-checkbox text-left"
        >
          <input
            :id="`academic-load-prerequisite-${option.id}`"
            v-model="selected_ids"
            type="checkbox"
            class="custom-control-input"
            :value="option.id"
          />
          <label
            class="custom-control-label"
            :for="`academic-load-prerequisite-${option.id}`"
            >{{ option.label }}</label
          >
        </div>
      </div>
    </template>
    <template #footer>
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        :disabled="saving"
        @click="save"
      >
        {{ saving ? $t("reusable.common.saving") : $t("reusable.common.save") }}
      </button>
    </template>
  </BsModal>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Pre-requisitos de una asignatura del perfil en la Carga Académica. Las opciones son las
// mismas que en el Plan de Estudio: asignaturas del perfil de un semestre igual o anterior.
import { computed, getCurrentInstance, ref, watch } from "vue";
import * as names from "@/store/names";
import { toast } from "@/utils/utils";
import BsModal from "@/components/reusable/bs/BsModal";

const props = defineProps({
  // Asignatura del perfil a editar; null cierra el modal
  egress_profile_matter: {
    type: Object,
    default: null,
  },
  profile_matters: {
    type: Array,
    required: true,
  },
  matters: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["close"]);

const proxy = getCurrentInstance().proxy;

const search = ref("");
const selected_ids = ref([]);
const saving = ref(false);

watch(
  () => props.egress_profile_matter,
  (egress_profile_matter) => {
    search.value = "";
    selected_ids.value = egress_profile_matter
      ? [...egress_profile_matter.prerequisites]
      : [];
  },
  { immediate: true }
);

const options = computed(() => {
  const current = props.egress_profile_matter;
  if (!current) return [];
  return props.profile_matters
    .filter(
      (x) => x.plan_level <= current.plan_level && x.matter != current.matter
    )
    .map((x) => {
      const matter = props.matters.find((m) => m.id == x.matter);
      return {
        id: x.id,
        label: `${x.effective_code} - ${matter ? matter.name : ""}`,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
});

// Las seleccionadas se mantienen visibles aunque no calcen con la búsqueda
const visibleOptions = computed(() =>
  options.value.filter(
    (x) =>
      proxy.$filtered(x.label, search.value) ||
      selected_ids.value.includes(x.id)
  )
);

// $restful y no la acción PATCH del store, que no rechaza si falla: el botón quedaría
// deshabilitado. Si falla, api.js ya mostró el error.
function save() {
  saving.value = true;
  proxy.$restful
    .Patch(`/mesh/egress-profile-matter/${props.egress_profile_matter.id}/`, {
      prerequisites: selected_ids.value,
    })
    .then((response) => {
      proxy.$store.commit(names.MUTATE_EGRESS_PROFILE_MATTER, response);
      toast(proxy.$t("studyPlan.academicLoad.changeMade"));
      emit("close");
    })
    .catch(() => {})
    .finally(() => {
      saving.value = false;
    });
}
</script>

<style scoped>
.options-list {
  max-height: 22rem;
  overflow-y: auto;
}
</style>
